import React, { useState } from 'react';
import '../css/Events.css';

const Events = () => {
    const [currentDate, setCurrentDate] = useState(new Date());

    // Хелперы для работы с датами
    const daysOfWeek = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
    const monthNames = [
        "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
        "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"
    ];

    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();

    // Первый день месяца (0 = Вс, 1 = Пн...)
    const firstDayOfMonth = new Date(year, month, 1).getDay();
    // Количество дней в месяце
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    // Сдвиг для того, чтобы неделя начиналась с Понедельника
    // В JS: 0-Вс, 1-Пн... Нам нужно: 0-Пн, 6-Вс
    const startOffset = firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1;

    // Генерация массива ячеек
    const calendarDays = [];
    for (let i = 0; i < startOffset; i++) {
        calendarDays.push(<div key={`empty-${i}`} className="day empty"></div>);
    }
    for (let d = 1; d <= daysInMonth; d++) {
        const isToday =
            d === new Date().getDate() &&
            month === new Date().getMonth() &&
            year === new Date().getFullYear();

        calendarDays.push(
            <div key={d} className={`day ${isToday ? 'today' : ''}`}>
                {d}
            </div>
        );
    }

    const changeMonth = (offset) => {
        setCurrentDate(new Date(year, month + offset, 1));
    };

    return (
        <div className="Events">
            <div className="calendar-container">
                {/* Шапка календаря */}
                <div className="calendar-header">
                    <button onClick={() => changeMonth(-1)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                             className="">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                            <path d="M15 6l-6 6l6 6"/>
                        </svg>
                    </button>
                    <h2>{monthNames[month]} {year}</h2>
                    <button onClick={() => changeMonth(1)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                             className="">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 6l6 6l-6 6" />
                        </svg>
                    </button>
                </div>

                {/* Дни недели */}
                <div className="calendar-grid">
                    {daysOfWeek.map(d => (
                        <div key={d} className="weekday">{d}</div>
                    ))}
                    {/* Сами числа */}
                    {calendarDays}
                </div>
            </div>
        </div>
    );
};

export default Events;